(function(angular) {
    'use strict'; 
    window.THF.Angular.JoinForm.factory('thfFieldDefinitionPayment', function() {       
        return {
            'paymentAccountName': {
                'label': 'Account Holder\'s Name',
                'labelStyle': '',
                'name': 'paymentAccountName',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 40,
                'tooltip': 'If the account holder is not covered by this policy (e.g. if a parent or partner is paying for your membership) we may contact you to verify that we have the account holder\'s permission to make deductions from their bank account.',
                'validation': [
                    'required'
                ]
            },
            'paymentAccountNumber': {
                'label': 'Account Number',
                'labelStyle': '',
                'name': 'paymentAccountNumber',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 9,
                'inputOnly': '^[0-9]$',
                'tooltip': 'Unfortunately, we cannot accept Direct Debit payments from a credit card',
                'validation': [
                    'required',
                    'thfAccountNumber'
                ]
            },
            'paymentAccountBSB': {
                'label': 'BSB Number',
                'labelStyle': '',
                'name': 'paymentAccountBSB',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'mask': '999-999',
                'validation': [
                    'required',
                    'thfPreValidated'
                ]
            },
            'paymentFrequency': {
                'label': 'Payment Frequency',
                'labelStyle': '',
                'name': 'paymentFrequency',
                'defaultValue': 'Fortnightly',
                'placeholder': '',
                'tooltip': '',
                'options': angular.copy(joinFormPageData.frequency),
                'onChange': function(newValue, oldValue, tabModel, formModel, field, formField) {
                    var coverStartDate = formModel.cover.coverStartDate;
                    formField.payment.paymentInitialDeductionDate.datePickerOptions.minDate = moment(coverStartDate).toDate();
                    formField.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(coverStartDate).add(1, 'month').toDate();
                    if( newValue == 'Fortnightly' ) {
                        formField.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(coverStartDate).add(2, 'weeks').toDate();
                    }
                },
                'validation': [
                    'required'
                ]
            },
            'paymentInitialDeductionDate': {
                'label': 'Initial Deduction Date',
                'labelStyle': '', 
                'name': 'paymentInitialDeductionDate',
                'defaultValue': moment().format('YYYY-MM-DD'),
                'placeholder': 'DD/MM/YYYY',
                'mask': '99/99/9999',
                'datePickerOptions': {
                    minDate: moment().toDate()
                },
                'tooltip': '',
                'validation': [
                    'required',
                    'thfDeductionDate'
                ]
            },
            'agreeDirectDebit': {
                'label': '',
                'labelStyle': '',
                'name': 'agreeDirectDebit',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {                        
                         'label':
                            `I agree to the terms of the
                            <a href="${
                            joinFormPageData.siteName === 'Teachers Health' ? 'https://www.teachershealth.com.au/assets/direct-debit-agreement.pdf' : 
                            joinFormPageData.siteName === 'Nurses & Midwives Health' ? 'https://www.nmhealth.com.au/assets/direct-debit-agreement.pdf' :
                            joinFormPageData.siteName === 'UniHealth' ? 'https://www.unihealthinsurance.com.au/assets/direct-debit-agreement.pdf' :
                                'https://www.teachershealth.com.au/assets/direct-debit-agreement.pdf'
                            }" target="_blank" rel="noopener noreferrer">
                            Direct Debit Agreement</a>`,
                        'value': 'Y'
                     }
                ],
                'validation': [
                    'required',
                    'requiredCheckbox'
                ]
            },

            'benefitsSameAsAbove': {
                'label': '',
                'labelStyle': '',
                'name': 'benefitsSameAsAbove',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {'label': 'Pay my benefits to the same account as above', 'value': 'Y'}
                ],
                'validation': []
            },

            'benefitsAccountName': {
                'label': 'Account Holder\'s Name',
                'labelStyle': '',
                'name': 'benefitsAccountName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 40,
                'validation': [
                    'required'
                ]
            },
            'benefitsAccountNumber': {
                'label': 'Account Number',
                'labelStyle': '',
                'name': 'benefitsAccountNumber',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 9,
                'inputOnly': '^[0-9]$',
                'tooltip': '',
                'validation': [
                    'required',
                    'thfAccountNumber'
                ]
            },
            'benefitsAccountBSB': {
                'label': 'BSB Number',
                'labelStyle': '',
                'name': 'benefitsAccountBSB',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'mask': '999-999',
                'validation': [
                    'required',
                    'thfPreValidated'
                ]
            }
        };
    });
})(angular);
